<template>
    <div class="dropdown">
        <button class="btn btn-info dropdown-toggle" type="button" id="ddOpciones" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="!selectedGrupoId">Más</button>

        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="ddOpciones">
            <h6 class="dropdown-header text-info">Exportar</h6>
            <a class="dropdown-item" :href="`/grupos-administrativos/exportarAExcel/${selectedGrupoId}/${selectedCicloId}`">
                <i class="fas fa-file-excel mr-1 text-muted"></i> Excel
            </a>

            <div class="dropdown-divider"></div>

            <h6 class="dropdown-header text-info">Números de lista</h6>

            <button class="dropdown-item" @click="autocompletar()">
                <i class="fas fa-magic mr-1"></i> Autocompletar
            </button>

            <button class="dropdown-item" @click="reiniciar()">
                <i class="fas fa-undo mr-1"></i> Reiniciar
            </button>

            <!-- <h6 class="dropdown-header text-info">Acciones</h6>

            <vs-switch style="max-width: 100px; margin: 0px 0px 0px 12%;" @input="activarDesactivarCicloEscolar()" v-model="grupoActivo">
                <template #off>
                    Desactivado
                </template>
                <template #on>
                    Activado
                </template>
            </vs-switch> -->

            <div class="dropdown-divider"></div>

            <h6 class="dropdown-header text-info">Más opciones</h6>

            <button class="dropdown-item" data-toggle="modal" data-target="#EditGroupModal">
                <i class="fas fa-edit mr-1"></i> Editar grupo
            </button>

            <button class="dropdown-item" @click="deleteGrupo()">
                <i class="fas fa-trash mr-1"></i> Eliminar grupo
            </button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'AccionesGrupo',
    inject: ['gruposRefresh$', 'alumnosRefresh$', 'selectedGrupoChange$', 'selectedCicloChange$'],
    data() {
        return {
            grupoActivo: true,
            selectedGrupoId: '',
            selectedCicloId: ''
        }
    },
    mounted() {
        this.selectedCicloChange$.subscribe(ciclo => this.selectedCicloId = ciclo?.id);
        this.selectedGrupoChange$.subscribe(grupo => this.selectedGrupoId = grupo?.id);
    },
    methods: {
        async deleteGrupo() {
            if (confirm('¿Está seguro que desea eliminar el grupo?')) {
                await axios.post('/grupos-administrativos/eliminarGrupo', { grupo_id: this.selectedGrupoId });
                toastr["success"]('Grupo académico Eliminado', "Éxito");
                this.gruposRefresh$.next();
            }
        },
        async reiniciar() {
            this.loading = true;
            await axios.post('/grupos-administrativos/reiniciarLista', {
                grupo_id: this.selectedGrupoId,
                ciclo_id: this.selectedCicloId
            });
            this.loading = false;
            this.alumnosRefresh$.next();
            toastr["success"]('Lista reiniciada', "Éxito");
        },
        async autocompletar() {
            this.loading = true;
            await axios.post('/grupos-administrativos/generarLista', {
                grupo_id: this.selectedGrupoId,
                ciclo_id: this.selectedCicloId
            });
            this.loading = false;
            this.alumnosRefresh$.next();
            toastr["success"]('Lista generada', "Éxito");
        },
        async activarDesactivarCicloEscolar() {
            await axios.post('/grupos-administrativos/activarDesactivar', {
                ciclo_escolar_id: this.selectedCicloId,
                grupo_id: this.selectedGrupoId,
                active: this.grupoActivo ? 1 : 0
            });

            this.selectedGrupoChange$.next();
        }
    }
}
</script>

<style>

</style>
